import { AxiosInstance } from 'axios';
import { responseHandler } from './response';
import { User } from '../../models/user';

export const updatePassword = async (client: AxiosInstance, body:{newPassword?:string, oldPassword?:string}) =>
  responseHandler<void>(client.post(`/security/updatePassword`, body))
